import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { toast } from 'sonner';
import { adminAPI } from '../../services/api';
import { LogIn } from 'lucide-react';

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await adminAPI.login(password);
      toast.success('Connexion réussie!');
      navigate('/admin/recipes');
    } catch (error) {
      toast.error('Mot de passe incorrect');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-primary">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
        <h1 className="text-3xl font-bold mb-6 text-center" style={{ fontFamily: 'var(--font-serif)' }}>
          Admin Soul Kitchen
        </h1>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
              Mot de passe
            </label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Entrez le mot de passe admin"
              required
              autoFocus
            />
          </div>
          <Button type="submit" className="w-full btn-primary" disabled={loading}>
            {loading ? 'Connexion...' : 'Se connecter'}
            <LogIn className="ml-2" size={20} />
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
